module.exports = __webpack_public_path__ + "static/sprinklr-3f1fc1890fb59a1313701b6848343283.png";